import * as commonService from "@/services/common.ts";
const Model = {
  namespace: 'common',
  state: {
    eventData: {},
  },
  effects: {
    // 获取左侧菜单
    getMenusData({ payload }: any, { call }: any) {
      return call(commonService.getMenus, payload);
    },
  },
  reducers: {

  },
};
export default Model;
